if (!customElements.get("collection-load-more")) {
  class CollectionLoadMore extends HTMLElement {
    constructor() {
      super();

      this.loadMoreButton = this.querySelector("#paginate-next");
      this.productsOnPage = document.getElementById("product-grid");
      this.loading = false;
      this.observer = null;

      this.loadMoreProducts = this.loadMoreProducts.bind(this);
      this.onIntersect = this.onIntersect.bind(this);
    }

    connectedCallback() {
      // Defer observer creation
      this.deferInit();
    }

    deferInit() {
      const init = () => this.initObserver();

      // Interaction-based init (iOS safe)
      ["touchstart", "wheel", "keydown"].forEach((event) => {
        window.addEventListener(event, init, {
          once: true,
          passive: true,
        });
      });

      // Fallback (in case no interaction)
      setTimeout(init, 3000);
    }

    initObserver() {
      if (!this.loadMoreButton || this.observer) return;

      this.observer = new IntersectionObserver(this.onIntersect, {
        root: null,
        rootMargin: "200px 0px",
        threshold: 0,
      });

      this.observer.observe(this.loadMoreButton);
    }

    onIntersect(entries) {
      const entry = entries[0];

      if (!entry.isIntersecting || this.loading) return;

      this.loadMoreProducts();
    }

    async getNextPage(next_url) {
      const res = await fetch(next_url, { credentials: "same-origin" });
      return await res.text();
    }

    async loadMoreProducts() {
      const paginateButton = this.loadMoreButton;
      if (!paginateButton?.dataset.href) return;

      this.loading = true;

      // IMPORTANT: disconnect fully
      this.observer.disconnect();

      paginateButton.disabled = true;
      paginateButton.querySelector(".loading__spinner")?.classList.remove("tw-hidden");

      try {
        const nextPage = await this.getNextPage(paginateButton.dataset.href);
        const doc = new DOMParser().parseFromString(nextPage, "text/html");

        const productGrid = doc.getElementById("product-grid");
        const newProducts = productGrid?.querySelectorAll(".product-grid__item") || [];
        const newButton = doc.getElementById("paginate-next");

        // Append in a single frame
        const fragment = document.createDocumentFragment();
        newProducts.forEach((p) => fragment.appendChild(p));
        this.productsOnPage.appendChild(fragment);

        if (newButton?.dataset.href) {
          paginateButton.dataset.href = newButton.dataset.href;
          paginateButton.innerHTML = newButton.innerHTML;
          paginateButton.disabled = false;

          // Re-observe AFTER layout settles
          requestAnimationFrame(() => {
            this.observer.observe(paginateButton);
          });
        } else {
          paginateButton.remove();
        }

        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  customElements.define("collection-load-more", CollectionLoadMore);
}
